/* eslint-disable max-statements */
import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core'

const SCROLL_AMOUNT = 4
const LEFT_BTN = 'button.left-btn'
const RIGHT_BTN = 'button.right-btn'
const DISPLAY_NONE = 'display-none-tab'
const START_EVENTS = ['mousedown', 'touchstart']
const END_EVENTS = ['mouseup', 'mouseout', 'touchend']
const SCROLLBAR_OFFSET = 18
const START_SCROLL_POSITION = 0
const SCROLL_DIRECTION_LEFT = -1
const SCROLL_DIRECTION_RIGHT = 1

@Directive({
  selector: '[scrollingTable]',
})
export class ScrollingTableDirective {
  innerWidth: number
  private readonly el: HTMLElement
  ro: ResizeObserver;

  isScrolling = false;
  scrollDirection = 0;

  constructor(
    private readonly ref: ElementRef,
    private readonly renderer: Renderer2,
  ) {
    this.el = ref.nativeElement
  }

  ngAfterViewInit() {
    this.addButtons()
    this.ro = new ResizeObserver((entries) => {
      window.requestAnimationFrame(() => {
        this.setScrollable(entries)
      })
      this.onScroll()
    })
    this.ro.observe(this.el)
  }

  ngOnDestroy() {
    this.ro.unobserve(this.el)
    this.isScrolling = false;
  }

  setScrollable(entries: any[]) {
    if (entries?.length > 0) {
      for (const entry of entries) {
        const target = entry.target.parentElement
        const noScroll = target.scrollWidth <= Math.ceil(target.getBoundingClientRect().width)
        if (!noScroll) {
          this.renderer.addClass(this.el, 'scrollable')
          this.onScroll()
        }
      }
    }
  }

  addButtons() {
    this.innerWidth = window.innerWidth
    this.el
      .insertAdjacentHTML(
        'beforeend',
        '<button class="left-btn" aria-label="Scroll left"></button>',
      );
    this.el
      .insertAdjacentHTML(
        'beforeend',
        '<button class="right-btn"  aria-label="Scroll right"></button>',
      );
    const leftBtn: HTMLElement = this.el.querySelector(LEFT_BTN);
    const rightBtn: HTMLElement = this.el.querySelector(RIGHT_BTN);

    START_EVENTS.forEach((event) => {
      leftBtn.addEventListener(event, () =>  this.onMouseDown(SCROLL_DIRECTION_LEFT))
      rightBtn.addEventListener(event, () =>  this.onMouseDown(SCROLL_DIRECTION_RIGHT))
    });
    END_EVENTS.forEach((event) => {
      leftBtn.addEventListener(event, () => this.onMouseUp());
      rightBtn.addEventListener(event, () => this.onMouseUp());
    });

    this.el.parentElement.addEventListener('scroll', () => {
      this.onScroll()
    });
  }

  onMouseDown(direction: number) {
    this.isScrolling = true;
    this.scrollDirection = direction;
    this.startScrolling();
  }

  onMouseUp() {
    this.isScrolling = false;
  }

  startScrolling() {
    if (this.isScrolling) {
      this.el.parentElement.scrollLeft += SCROLL_AMOUNT * this.scrollDirection
      requestAnimationFrame(() => this.startScrolling())
    }
  }

  @HostListener('window:resize')
  @HostListener('window:scroll')
  onScroll() {
    const parent = this.el.parentElement;
    const maxScrollLeft = Math.ceil(parent?.scrollWidth - parent?.clientWidth)
    const scrollPosition = parent?.scrollLeft ? Math.ceil(parent?.scrollLeft) : 0
    const leftBtn: HTMLElement = this.el.parentElement.querySelector(LEFT_BTN)
    const rightBtn: HTMLElement = this.el.parentElement.querySelector(RIGHT_BTN)
    const firstCell: HTMLElement = parent.querySelector('thead tr th:first-child')
    leftBtn.setAttribute(
      'style',
      `left: ${firstCell.offsetLeft - scrollPosition + firstCell.clientWidth}px; top: 20px; z-index:3;`
    )
    rightBtn.setAttribute(
      'style',
      `left: ${parent?.clientWidth - SCROLLBAR_OFFSET}px; top: 20px; z-index:3;`,
    )

    if (maxScrollLeft <= START_SCROLL_POSITION) {
      this.renderer.addClass(this.el.querySelector(LEFT_BTN), DISPLAY_NONE)
      this.renderer.addClass(this.el.querySelector(RIGHT_BTN), DISPLAY_NONE)
    } else {
      const scrollPosition = Math.ceil(parent.scrollLeft)
      if (scrollPosition > 0) {
        this.renderer.removeClass(this.el.querySelector(LEFT_BTN), DISPLAY_NONE)
        this.renderer.addClass(this.el.querySelector(RIGHT_BTN), DISPLAY_NONE)
      } else {
        this.renderer.addClass(this.el.querySelector(LEFT_BTN), DISPLAY_NONE)
      }
      if (scrollPosition < maxScrollLeft) {
        this.renderer.removeClass(this.el.querySelector(RIGHT_BTN), DISPLAY_NONE)
      } else {
        this.renderer.addClass(this.el.querySelector(RIGHT_BTN), DISPLAY_NONE)
      }
    }
  }
}
